import React, { useEffect, useLayoutEffect } from 'react';

// import { useIntercom } from 'react-use-intercom';

import useWindowSize from '../hooks/useWindowSize';
import usePageTracking from '../hooks/usePageTracking';

const WindowStateManager = (props) => {

  let {
    isConsideredMobile,
    setConsideredMobile,
    setConsideredMedium,
    location,
  } = props;

  // const {
  //   boot,
  //   // shutdown,
  //   // hide,
  //   // show,
  //   // update
  // } = useIntercom();

  // useEffect(() => {
  //   boot();
  // }, [boot])

  usePageTracking(location);

  const consentToCookies = true;

  useEffect(() => {
    if(!consentToCookies) {
      try {
        //@ts-ignore
        if(!window.document.__defineGetter__) {
          Object.defineProperty(document, 'cookie', {
              get: function(){return ''},
              set: function(){return true},
          });
        } else {
          //@ts-ignore
          window.document.__defineGetter__("cookie", function() { return '';} );
          //@ts-ignore
          window.document.__defineSetter__("cookie", function() {} );
        }
      } catch (e) {
        console.error("Error encountered when attempting to block cookie functionality", e);
      }
    } else {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'hs-script-loader';
      script.async = true;
      script.defer = true;
      script.src = '//js.hs-scripts.com/4204561.js';

      document.head.appendChild(script);

      // Cleanup function to remove the script when the component unmounts or when consentToCookies changes to false
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [consentToCookies])

  console.log({isConsideredMobile})

  const windowSize = useWindowSize();

  useLayoutEffect(() => {
    let sizeConsiderMobile = 1100;
    let sizeConsideredMedium = 1535;
    if (windowSize.width && (windowSize.width <= sizeConsiderMobile)) {
      setConsideredMobile(true);
    } else if (windowSize.width) {
      setConsideredMobile(false);
    }
    if (windowSize.width && (windowSize.width <= sizeConsideredMedium)) {
      setConsideredMedium(true);
    } else if (windowSize.width) {
      setConsideredMedium(false);
    }
  }, [windowSize.width, windowSize.height, setConsideredMobile, setConsideredMedium])

  return (
    <></>
  );
}

export default WindowStateManager